// extracted by mini-css-extract-plugin
module.exports = {"faq":"scheduleResultsFAQs_faq__mK3FF","title":"scheduleResultsFAQs_title__mLxnt","description":"scheduleResultsFAQs_description__66Pym"};